// src/components/reviews/RatingStars.tsx
import React from 'react';
import { StarIcon } from '@heroicons/react/24/solid';
import { StarIcon as StarOutlineIcon } from '@heroicons/react/24/outline';

interface RatingStarsProps {
    rating: number;
    size?: number;
    showValue?: boolean;
    interactive?: boolean;
    onRatingChange?: (rating: number) => void;
}

export const RatingStars: React.FC<RatingStarsProps> = ({
                                                            rating,
                                                            size = 20,
                                                            showValue = false,
                                                            interactive = false,
                                                            onRatingChange
                                                        }) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    const handleClick = (index: number) => {
        if (interactive && onRatingChange) {
            onRatingChange(index + 1);
        }
    };

    return (
        <div className="rating-stars" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <div style={{ display: 'flex', gap: '2px' }}>
                {[...Array(fullStars)].map((_, i) => (
                    <StarIcon
                        key={`full-${i}`}
                        style={{ width: size, height: size, color: '#f59e0b', cursor: interactive ? 'pointer' : 'default' }}
                        onClick={() => handleClick(i)}
                    />
                ))}
                {hasHalfStar && (
                    <div style={{ position: 'relative', width: size, height: size }}>
                        <StarOutlineIcon style={{ width: size, height: size, color: '#f59e0b', position: 'absolute' }} />
                        <StarIcon style={{ width: size * 0.5, height: size, color: '#f59e0b', position: 'absolute', overflow: 'hidden' }} />
                    </div>
                )}
                {[...Array(emptyStars)].map((_, i) => (
                    <StarOutlineIcon
                        key={`empty-${i}`}
                        style={{ width: size, height: size, color: '#d1d5db', cursor: interactive ? 'pointer' : 'default' }}
                        onClick={() => handleClick(fullStars + (hasHalfStar ? 1 : 0) + i)}
                    />
                ))}
            </div>
            {showValue && <span style={{ fontSize: '14px', color: '#6b7280' }}>({rating.toFixed(1)})</span>}
        </div>
    );
};